// import axios from "axios";

// const axiosInstance = axios.create({
//   baseURL: process.env.REACT_APP_BACKEND_URL,
// });
// console.log("BASE URL:", process.env.REACT_APP_BACKEND_URL);

// // Attach token automatically
// axiosInstance.interceptors.request.use(

//   (config) => {
//     const token = localStorage.getItem("token");

//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// export default axiosInstance;
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

api.interceptors.request.use((config) => {
  // If the caller already set an explicit Authorization header, don't override it
  if (config.headers?.Authorization) return config;

  const role = localStorage.getItem("role");

  let tokenToUse = null;

  const PARTNER_ROLES = ["partner", "partner_co_admin", "co_admin", "partner_instructor", "instructor"];

  if (role === "admin") {
    tokenToUse = localStorage.getItem("adminToken");
  } else if (PARTNER_ROLES.includes(role)) {
    // partnerToken may be in sessionStorage when "remember me" was off
    tokenToUse =
      localStorage.getItem("partnerToken") ||
      sessionStorage.getItem("partnerToken");
  } else if (role === "tutor") {
    // tutorToken may be in sessionStorage when "remember me" was off
    tokenToUse =
      localStorage.getItem("tutorToken") ||
      sessionStorage.getItem("tutorToken");
  } else {
    tokenToUse = localStorage.getItem("token");
  }

  console.log("Role:", role);
  console.log("Token used:", tokenToUse);

  if (tokenToUse) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${tokenToUse}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("API 401 on", error.config?.url);
    }
    return Promise.reject(error);
  },
);

export default api;
